@if (fieldCaption) {
  <label class="property-name">
    {{ fieldCaption | translate }}
  </label>
}
<mat-radio-group [formGroup]="parentFormGroup">
  @for (item of items; track item) {
    <mat-radio-button (change)="onOptionChange($event)" [value]="item.value" [checked]="item.value === control.value">{{
      item.displayName | translate
    }}</mat-radio-button>
  }
</mat-radio-group>

@if (control?.touched && control?.invalid) {
  <mat-error>
    {{ 'ERROR.REQUIRED' | translate }}
  </mat-error>
}
